import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import axios from 'axios'

import ApplicationLayout from '../leevo_ui/ApplicationLayout/ApplicationLayout'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs'
import { Card } from '../ui/card'
import ReportGenerationForm from './ReportGenerationForm/ReportGenerationForm'
import ReportHistory from './ReportHistory/ReportHistory'

function AdminReportsCenter() {
  const [isLoading, setIsLoading] = useState(true)
  const [facilities, setFacilities] = useState([])
  const [activeTab, setActiveTab] = useState('generate')
  const { replace: redirect } = useHistory()
  const { facility_id: facilityId } = useParams()

  const isFacilityScoped = !!facilityId
  const apiBasePath = isFacilityScoped ? `/api/facilities/${facilityId}/reports` : '/api/admin/reports'

  useEffect(() => {
    loadInitialData()
  }, [redirect, facilityId])

  async function loadInitialData() {
    try {
      if (isFacilityScoped) {
        const response = await axios.get(`/api/facilities/${facilityId}`)
        setFacilities([
          {
            id: response.data.data.id,
            name: response.data.data.attributes.name,
            demo: response.data.data.attributes.demo
          }
        ])
      } else {
        const response = await axios.get('/api/admin/reports/facilities')
        setFacilities(response.data)
      }
    } catch (error) {
      if (error.response?.status === 401) {
        redirect('/login')
      } else if (error.response?.status === 403) {
        redirect('/404')
      } else {
        throw error
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ApplicationLayout isContentLoading={isLoading}>
      <div className="min-h-screen bg-gray-100 pb-10">
        <div className="px-4 py-6 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">Reports</h1>
            <p className="mt-1 text-sm text-gray-600 sm:mt-2">Generate and download reports for your facility</p>
          </div>

          <Card className="p-6">
            <Tabs value={activeTab} onValueChange={setActiveTab}>
              <TabsList className="mb-6">
                <TabsTrigger value="generate">Generate Reports</TabsTrigger>
                <TabsTrigger value="history">Report History</TabsTrigger>
              </TabsList>

              <TabsContent value="generate">
                <ReportGenerationForm
                  facilities={facilities}
                  apiBasePath={apiBasePath}
                  isFacilityScoped={isFacilityScoped}
                  demo={facilities.some((facility) => facility.demo)}
                />
              </TabsContent>

              <TabsContent value="history">
                <ReportHistory apiBasePath={apiBasePath} />
              </TabsContent>
            </Tabs>
          </Card>
        </div>
      </div>
    </ApplicationLayout>
  )
}

export default AdminReportsCenter
